module.exports = [
  {
    url: '/depart/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            depart_id: '828735811590553600',
            name: '根节点',
            code: '44130000',
            remark: '啊啊啊',
            pid: '0',
            create_user_id: '100',
            create_time: '2024-01-29 20:25:06',
            update_time: '2024-01-29 20:25:06',
            deleted: 0,
          },
          {
            depart_id: '222',
            name: '一级1',
            code: '44130000',
            remark: '啊啊啊',
            pid: '828735811590553600',
            create_user_id: '100',
            create_time: '2024-01-29 20:25:06',
            update_time: '2024-01-29 20:25:06',
            deleted: 0,
          },
          {
            depart_id: '333',
            name: '一级2',
            code: '44130000',
            remark: '啊啊啊',
            pid: '828735811590553600',
            create_user_id: '100',
            create_time: '2024-01-29 20:25:06',
            update_time: '2024-01-29 20:25:06',
            deleted: 0,
          },
          {
            depart_id: '444',
            name: '二级1',
            code: '44130000',
            remark: '啊啊啊',
            pid: '222',
            create_user_id: '100',
            create_time: '2024-01-29 20:25:06',
            update_time: '2024-01-29 20:25:06',
            deleted: 0,
          },
          {
            depart_id: '555',
            name: '二级2',
            code: '44130000',
            remark: '啊啊啊',
            pid: '222',
            create_user_id: '100',
            create_time: '2024-01-29 20:25:06',
            update_time: '2024-01-29 20:25:06',
            deleted: 0,
          },
        ],
      }
    },
  },
  {
    url: '/depart/get',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          depart_id: '828735811590553600',
          name: '大亚湾区公安局',
          code: '44130000',
          remark: '111',
          pid: '0',
          create_user_id: '100',
          create_time: '2024-01-29 20:25:06',
          update_time: '2024-01-29 20:37:31',
          deleted: 0,
        },
      }
    },
  },
  {
    url: '/depart/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/depart/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/depart/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
]
